module.exports = __webpack_public_path__ + "static/images/qrcode_qq.1c024f7.jpg";